// getBackendErrorMessage - возвращает локализованное сообщение об ошибке бэкенда
export const getBackendErrorMessage = (error, fallbackMessage = 'Произошла ошибка') => {
    const response = error?.response?.data?.response ?? error?.response?.data ?? error?.response;
    const message = response?.error || response?.message || error?.message;
    if (!message) {
        return fallbackMessage;
    }

    const code = response?.code;
    const messageKey = code ? `${code}:${message}` : message;
    const localizedMessage = backendErrorMessageMap[messageKey] || backendErrorMessageMap[message];

    return localizedMessage || message || fallbackMessage;
};

// Карта локализаций сообщений бэкенда.
const backendErrorMessageMap = {
    'ERR_VALIDATION:player hint balance is not enough': 'Недостаточно подсказок',
    'player hint balance is not enough': 'Недостаточно подсказок',
    'ERR_VALIDATION:no hints left': 'Лимит подсказок в игре исчерпан',
    'no hints left': 'Лимит подсказок в игре исчерпан',
    'ERR_VALIDATION:no words left to reveal': 'На поле не осталось слов для подсказки',
    'no words left to reveal': 'На поле не осталось слов для подсказки',
    'ERR_VALIDATION:no_words_left_to_reveal': 'На поле не осталось слов для подсказки',
    'no_words_left_to_reveal': 'На поле не осталось слов для подсказки',
    'ERR_WRONG_GAME_STATUS:game not found or not active': 'Нет активной игры',
    'game not found or not active': 'Нет активной игры',
    'ERR_WRONG_GAME_STATUS:game is already finished': 'Игра уже завершена',
    'game is already finished': 'Игра уже завершена',
    'ERR_WRONG_GAME_STATUS:game not found': 'Игра не найдена',
    'game not found': 'Игра не найдена'
};
